import { useState } from "react";
import { DescriptionContainer, DetailsContainer, ImageContainer, ProductsContainer, ProgressBar, ProgressIndicator, TabItem, TabList, TabsWrapper } from "./styled"
import { descriptions, tabs } from "./constants";
import NeedlesImage from "./Images/NeedlesImage";
import SuturesImage from "./Images/SuturesImage";
import SurgicalMeshImage from "./Images/SurgicalMeshImage";
import NeedleDetails from "./Details/NeedleDetails/NeedleDetails";
import SuturesDetails from "./Details/SuturesDetails/SuturesDetails";
import SurgicalMeshDetails from "./Details/SurgicalMeshDetails/SurgicalMeshDetails";

const Products = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  return <ProductsContainer>
    <TabsWrapper>
      <TabList>
        {tabs.map((tab, index) => (
          <TabItem
            key={tab}
            active={index === activeIndex}
            onClick={() => setActiveIndex(index)}
          >
            {tab}
            <ProgressBar>
              { index === activeIndex && <ProgressIndicator />}
            </ProgressBar>
          </TabItem>
        ))}
      </TabList>
  </TabsWrapper>
  <ImageContainer>
    {
      activeIndex === 0 ? <NeedlesImage /> :
      activeIndex === 1 ? <SuturesImage /> :
      <SurgicalMeshImage />
    }
  </ImageContainer>
  <DescriptionContainer>{descriptions[activeIndex]}</DescriptionContainer>
  <DetailsContainer>
    {
      activeIndex === 0 ? <NeedleDetails /> :
      activeIndex === 1 ? <SuturesDetails /> :
      <SurgicalMeshDetails />
    }
  </DetailsContainer>
  </ProductsContainer>
}

export default Products;